var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-textbox-step-input" },
    _vm._l(_vm.setpTemplateList, function (item) {
      return _c(
        "span",
        { key: item.index, staticClass: "ds-textbox-step-warp" },
        [
          item.type == "input"
            ? _c("div", { staticClass: "el-input" }, [
                _c("input", {
                  ref: "input",
                  refInFor: true,
                  staticClass: "el-input__inner",
                  class: { "is-disabled": _vm.disabled },
                  attrs: {
                    "char-index": item.index,
                    num: item.num,
                    maxlength: 1,
                    type: _vm.inputType,
                    disabled: _vm.disabled,
                    autocomplete: "off",
                  },
                  domProps: { value: _vm.val[item.index] },
                  on: {
                    input: function ($event) {
                      return _vm.onInput($event, item)
                    },
                    focus: function ($event) {
                      return _vm.onFocus($event, item.num)
                    },
                    blur: function ($event) {
                      return _vm.onBlur($event, item.num)
                    },
                    compositionstart: function ($event) {
                      return _vm.onCompositionstart($event, item.num)
                    },
                    compositionend: function ($event) {
                      return _vm.onCompositionend($event, item.num)
                    },
                  },
                }),
              ])
            : _c(
                "span",
                { staticClass: "ds-textbox-step-warp", attrs: { split: "" } },
                [_vm._v(_vm._s(item.text))]
              ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }